module.exports = require("errorhandler");


/*****************
 ** WEBPACK FOOTER
 ** external "errorhandler"
 ** module id = 3
 ** module chunks = 0
 **/